module.exports = __webpack_public_path__ + "static/media/GroundBlind.svg";